export default (debt, funeralCost) => {
    return debt + funeralCost;
}
